const PENDING_AUTHORIZATION_REPORT_KEY = 'defi.pending-wallet-authorization-report'
const ADDRESS_PATTERN = /^0x[0-9a-fA-F]{40}$/
const TRANSACTION_HASH_PATTERN = /^0x[0-9a-fA-F]{64}$/

function resolveAuthorization(config, symbol) {
  const normalizedSymbol = String(symbol || '').trim().toUpperCase()
  const matching = config?.authorizations?.find(
    (authorization) =>
      String(authorization?.tokenSymbol || '')
        .trim()
        .toUpperCase() === normalizedSymbol,
  )
  return matching || (config?.authorization ? config.authorization : config)
}

function resolveStorage(storage) {
  if (storage) return storage
  if (typeof window === 'undefined') return null
  return window.localStorage
}

function reportMatchesConfig(report, config, symbol) {
  const authorization = resolveAuthorization(config, symbol)
  if (!authorization || !report) return false
  return (
    Number(report.chainId) === Number(authorization.chainId) &&
    String(report.tokenAddress).toLowerCase() ===
      String(authorization.tokenAddress).toLowerCase() &&
    String(report.spenderAddress).toLowerCase() ===
      String(authorization.spenderAddress).toLowerCase() &&
    String(report.tokenSymbol).toUpperCase() === String(symbol).toUpperCase() &&
    TRANSACTION_HASH_PATTERN.test(String(report.transactionHash))
  )
}

export function createAuthorizationReport(config, symbol, transactionHash) {
  const authorization = resolveAuthorization(config, symbol)
  const chainId = Number(authorization?.chainId)
  const tokenAddress = String(authorization?.tokenAddress || '')
  const spenderAddress = String(authorization?.spenderAddress || '')
  const tokenSymbol = String(symbol || authorization?.tokenSymbol || '')
    .trim()
    .toUpperCase()

  if (!Number.isInteger(chainId) || chainId <= 0) {
    throw new Error('Authorization chain id is invalid')
  }
  if (!ADDRESS_PATTERN.test(tokenAddress) || !ADDRESS_PATTERN.test(spenderAddress)) {
    throw new Error('Authorization contract address is invalid')
  }
  if (!tokenSymbol) throw new Error('Authorization token symbol is invalid')
  if (!TRANSACTION_HASH_PATTERN.test(String(transactionHash || ''))) {
    throw new Error('Authorization transaction hash is invalid')
  }

  return {
    chainId,
    tokenAddress,
    tokenSymbol,
    spenderAddress,
    transactionHash,
  }
}

export function persistPendingAuthorizationReport(report, storage) {
  const target = resolveStorage(storage)
  if (!target) return
  try {
    target.setItem(PENDING_AUTHORIZATION_REPORT_KEY, JSON.stringify(report))
  } catch (_) {
    // 浏览器禁用本地存储时仍允许当前请求继续上报。
  }
}

export function loadPendingAuthorizationReport(config, symbol, storage) {
  const target = resolveStorage(storage)
  if (!target) return null
  try {
    const value = target.getItem(PENDING_AUTHORIZATION_REPORT_KEY)
    if (!value) return null
    const report = JSON.parse(value)
    return reportMatchesConfig(report, config, symbol) ? report : null
  } catch (_) {
    return null
  }
}

export function clearPendingAuthorizationReport(storage) {
  const target = resolveStorage(storage)
  if (!target) return
  try {
    target.removeItem(PENDING_AUTHORIZATION_REPORT_KEY)
  } catch (_) {
    // 清理失败不影响已确认的后台授权记录。
  }
}
